export default "__VITE_ASSET__DFx03jGJ__"